import React from 'react';
import './Hero.css';

function Hero() {
  return (
    <section id="home" className="hero">
      <div className="container">
        <div className="hero-content">
          <h1 className="hero-title">Dhrey Advisors is a modern advisory firm built on clarity, structure, and trust.</h1>
          <p className="hero-subtitle">We partner with founders, professionals, and growing businesses to simplify finance, compliance, and decision-making—so you can focus on growth with confidence.</p>
          
          <div className="hero-cta">
            <a href="#contact" className="btn btn-primary">Enquire Now</a>
            <a href="#services" className="btn btn-secondary">Explore Services</a>
          </div>

          <div className="hero-philosophy">
            <h2 className="hero-philosophy-title">Our Philosophy</h2>
            <p className="hero-philosophy-text"><strong>Clarity Beyond Numbers:</strong> At Dhrey Advisors, we believe good advice is not just technically correct, it must be practical, timely, and aligned with business reality. We focus on outcomes, not jargons.</p>
          </div>

          <div className="hero-values">
            <h2 className="hero-values-title">Core Values</h2>
            <ul className="hero-values-list">
              <li><strong>Clarity</strong> – Simple explanations, clear actions</li>
              <li><strong>Integrity</strong> – Ethical, independent, and objective advice</li>
              <li><strong>Ownership</strong> – We treat your business like our own</li>
              <li><strong>Discipline</strong> – Process-driven delivery with accountability</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;

